import { DataProxy } from 'apollo-cache'
import {
  GetPersonalTokensDocument,
  GetPersonalTokensQuery,
  GetPersonalTokensQueryVariables,
} from '@sketch/gql-types'

type Me = GetPersonalTokensQuery['me']

const get = (cache: DataProxy): Me | undefined => {
  try {
    return cache.readQuery<
      GetPersonalTokensQuery,
      GetPersonalTokensQueryVariables
    >({
      query: GetPersonalTokensDocument,
      variables: {},
    })?.me
  } catch {
    // There is no way to recover here and callers are already expecting
    // `undefined` as a possible return type, so we do nothing.
  }
}

const set = (cache: DataProxy, me: Me): void => {
  cache.writeQuery<GetPersonalTokensQuery, GetPersonalTokensQueryVariables>({
    query: GetPersonalTokensDocument,
    data: { __typename: 'RootQueryType', me },
  })
}

export { get, set }
